import { render, staticRenderFns } from "./bcgssljl.vue?vue&type=template&id=88ac2f58&scoped=true&"
import script from "./bcgssljl.vue?vue&type=script&lang=js&"
export * from "./bcgssljl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ac2f58",
  null
  
)

export default component.exports